export default __webpack_public_path__ + "static/media/favorites-toned-legs.09da032f.png";